// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================
   Design Tokens / Theme
   ========================================================== */
:root {
  --color-bg: #f5f7fa;
  --color-surface: #ffffff;
  --color-surface-alt: #f8f9fc;
  --color-border: #eef0f5;
  --color-border-strong: #dfe3ea;
  --color-text: #2f3441;
  --color-text-sec: #667085;
  --color-muted: #98a0ad;
  --color-primary: #6366f1; /* 主色 */
  --color-primary-accent: #4f46e5; /* 渐变副色 */
  --color-primary-hover: #5457e8;
  --color-primary-active: #4547d9;
  --color-danger: #f56c6c;
  --color-warning-bg: #fff7d6;
  --color-success-bg: #e6fbeb;
  --radius-xs: 4px;
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 18px;
  --shadow-sm: 0 1px 4px rgba(0,0,0,0.06);
  --shadow-md: 0 2px 8px rgba(0,0,0,0.08);
  --shadow-lg: 0 4px 16px rgba(0,0,0,0.12);
  --focus-ring: 0 0 0 3px rgba(99,102,241,.35);
  --transition-fast: .18s cubic-bezier(.4,0,.2,1);
  --transition-base: .28s cubic-bezier(.4,0,.2,1);
  --font-stack: -apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
}

/* Dark mode (可选) */
@media (prefers-color-scheme: dark) {
  :root {
    --color-bg: #1f242d;
    --color-surface: #2a303b;
    --color-surface-alt: #323a46;
    --color-border: #39424f;
    --color-border-strong: #485364;
    --color-text: #f5f7fa;
    --color-text-sec: #c3c9d2;
    --color-muted: #9aa4b2;
    --shadow-sm: 0 1px 3px rgba(0,0,0,.4);
    --shadow-md: 0 2px 8px rgba(0,0,0,.5);
    --shadow-lg: 0 4px 18px rgba(0,0,0,.55);
  }
}

/* ==========================================================
   Base / Reset (轻量增强)
   ========================================================== */
html { font-size: 16px; }
body { margin: 0; font-family: var(--font-stack); background: var(--color-bg); color: var(--color-text); -webkit-font-smoothing: antialiased; }

*, *::before, *::after { box-sizing: border-box; }

a { color: var(--color-primary); text-decoration: none; transition: color var(--transition-fast); }
a:hover { color: var(--color-primary-hover); }

/* 图片和媒体内容优化 */
img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: inherit; /* 继承父元素的圆角 */
}

/* 特定图片类型的优化 */
.service-thumb {
  object-fit: cover;
}

.nav-icon {
  object-fit: contain;
}

/* 响应式图片容器 */
.img-container {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-md);
}

.img-responsive {
  width: 100%;
  height: auto;
  object-fit: cover;
  transition: transform var(--transition-base);
}

.img-responsive:hover {
  transform: scale(1.02);
}

/* 图片加载优化 */
img[loading="lazy"] {
  opacity: 1; /* 修复：确保图片可见 */
  transition: opacity 0.3s;
}

img[loading="lazy"].loaded {
  opacity: 1;
}

/* 图片占位符 */
.img-placeholder {
  background: var(--color-surface-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-muted);
  font-size: 0.8rem;
  min-height: 120px;
  border-radius: var(--radius-md);
}

@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }
@keyframes fadeSlideUp { 0% { opacity:0; transform:translateY(12px);} 100% { opacity:1; transform:translateY(0);} }
@keyframes pulseSoft { 0%,100% { box-shadow:0 0 0 0 rgba(99,102,241,.35);} 50% { box-shadow:0 0 0 6px rgba(99,102,241,0);} }

/* App容器基础样式 */
.App {
  text-align: center;
  background: var(--color-bg);
  min-height: 100vh;
}

/* 有底部导航栏时的布局 */
.App.has-bottom-nav {
  padding-bottom: 64px;
}

/* 没有底部导航栏时的布局 */
.App.no-bottom-nav {
  padding-bottom: 0;
}

/* ==========================================================
   Layout Helpers
   ========================================================== */
.container { max-width:750px; margin:0 auto; padding:0 18px; }

/* 卡片统一样式 */
.card, .user-info-card, .success-card, .orders-list, .menu-list, .booking-form, .hero, .section, .order-card, .pay-card, .amount-card, .join-form .group {
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  transition: box-shadow var(--transition-base), transform var(--transition-base), background-color var(--transition-fast);
  position: relative;
}
.card:hover:not(.no-hover),
.user-info-card:hover,
.booking-form:hover { box-shadow: var(--shadow-lg); }

/* 统一顶部标题栏 */
.service-header, .booking-header, .payment-header, .detail-header, .join-header, .my-header, .profile-header, .success-header {
  background: linear-gradient(90deg,var(--color-primary),var(--color-primary-accent));
  color:#fff; padding:16px 20px; display:flex; align-items:center; backdrop-filter:saturate(180%) blur(6px);
  position: relative; z-index:10;
}
.service-header h1, .booking-header h1, .payment-header h1, .detail-header h1, .join-header h1, .my-header h1, .profile-header h1, .success-header h1 { font-size:1.125rem; letter-spacing:.5px; }

/* 返回按钮统一 */
.back-btn { color:#fff; font-size:.95rem; margin-right:14px; opacity:.9; transition:opacity var(--transition-fast), transform var(--transition-fast); }
.back-btn:hover { opacity:1; transform:translateX(-2px); }
.back-btn:focus-visible { outline:none; box-shadow: var(--focus-ring); border-radius: var(--radius-sm); }

/* ==========================================================
   Buttons
   ========================================================== */
.btn, .submit-btn, .book-now, .confirm-btn, .edit-btn, .code-btn, .tab, .detail-btn, .book-btn, .pay-option, .category-tab {
  font-family: inherit;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  min-height:44px; /* 确保触摸面积 */
}

.btn {
  display:inline-flex; align-items:center; justify-content:center; gap:6px; line-height:1.1;
  padding:12px 22px; font-size:.95rem; font-weight:600; letter-spacing:.3px;
  background: linear-gradient(135deg,var(--color-primary),var(--color-primary-accent));
  color:#fff; border:none; border-radius: var(--radius-md); cursor:pointer;
  position:relative; overflow:hidden; isolation:isolate;
  transition: background var(--transition-fast), transform var(--transition-fast), box-shadow var(--transition-fast);
  box-shadow:0 2px 4px rgba(0,0,0,.12), inset 0 0 0 1px rgba(255,255,255,.08);
}
.btn::after { content:""; position:absolute; inset:0; background:radial-gradient(circle at 30% 30%,rgba(255,255,255,.35),rgba(255,255,255,0)); opacity:0; transition:opacity var(--transition-fast); }
.btn:hover { transform:translateY(-2px); box-shadow:0 4px 12px rgba(0,0,0,.18); }
.btn:hover::after { opacity:1; }
.btn:active { transform:translateY(0); background: linear-gradient(135deg,var(--color-primary-hover),var(--color-primary-active)); }
.btn:focus-visible { outline:none; box-shadow: var(--focus-ring); }

.btn-secondary { background: var(--color-surface); color: var(--color-primary); box-shadow:0 1px 3px rgba(0,0,0,.08), inset 0 0 0 1px var(--color-border); }
.btn-secondary:hover { background: var(--color-surface-alt); }
.btn-secondary:active { background:#eceef5; }

.submit-btn, .book-now, .confirm-btn, .edit-btn, .detail-btn, .book-btn {
  background: linear-gradient(135deg,var(--color-primary),var(--color-primary-accent));
  color:#fff; border:none; font-weight:600;
  transition: background var(--transition-fast), transform var(--transition-fast), box-shadow var(--transition-fast);
}
.submit-btn:hover:not(:disabled), .book-now:hover, .confirm-btn:hover:not(:disabled), .edit-btn:hover, .detail-btn:hover, .book-btn:hover {
  background: linear-gradient(135deg,var(--color-primary-hover),var(--color-primary));
  transform: translateY(-2px);
  box-shadow:0 4px 12px rgba(0,0,0,.18);
}
.submit-btn:disabled, .confirm-btn:disabled { background: linear-gradient(135deg,#c9ced8,#c9ced8); cursor:not-allowed; box-shadow:none; }

.code-btn { background:#fff; color:var(--color-primary); font-weight:600; border:1px solid var(--color-primary); transition:var(--transition-fast); }
.code-btn:hover:not(:disabled) { background:var(--color-primary); color:#fff; }
.code-btn:focus-visible { outline:none; box-shadow: var(--focus-ring); }

/* Tabs / Category chips refine */
.category-tab, .tab { position:relative; font-weight:500; }
.category-tab.active, .tab.active { background: linear-gradient(135deg,var(--color-primary),var(--color-primary-accent)); color:#fff; border:none; box-shadow:0 2px 6px rgba(99,102,241,.35); }
.category-tab:focus-visible, .tab:focus-visible { outline:none; box-shadow: var(--focus-ring); }

/* ==========================================================
   Typography Helpers
   ========================================================== */
h1,h2,h3,h4 { font-weight:700; color:var(--color-text); line-height:1.25; }
p { line-height:1.6; }
small { color:var(--color-text-sec); }

/* ==========================================================
   Form Elements
   ========================================================== */
input, select, textarea { font-family:inherit; }
input, select, textarea {
  border:1px solid var(--color-border-strong); background:var(--color-surface);
  border-radius: var(--radius-md); padding:12px 14px; font-size:16px; line-height:1.25; transition:border-color var(--transition-fast), box-shadow var(--transition-fast), background-color var(--transition-fast);
  min-height:48px; /* 触摸区域 */
}
input:focus, select:focus, textarea:focus { outline:none; border-color:var(--color-primary); box-shadow: var(--focus-ring); }
textarea { resize: vertical; }
::placeholder { color: var(--color-muted); }

/* ==========================================================
   Utilities
   ========================================================== */
.fade-in { animation: fadeSlideUp .6s both; }
.spin { animation: spin 1s linear infinite; }
.pulse { animation:pulseSoft 2.4s infinite; }

.divider { height:1px; background:var(--color-border); margin:20px 0; }

/* Scrollbar refinement for webkit (可选) */
::-webkit-scrollbar { width:10px; height:10px; }
::-webkit-scrollbar-track { background:transparent; }
::-webkit-scrollbar-thumb { background:rgba(0,0,0,.15); border-radius:20px; }
::-webkit-scrollbar-thumb:hover { background:rgba(0,0,0,.25); }

/* Focus ring helper */
.focus-ring:focus-visible { outline:none; box-shadow: var(--focus-ring); }

/* ==========================================================
   Responsive Breakpoints System
   ========================================================== */

/* 大屏手机和小平板 (481px - 768px) */
@media (max-width: 768px) and (min-width: 481px) {
  .container { padding:0 16px; }
  .btn { font-size:.95rem; padding:12px 20px; }

  /* 卡片间距调整 */
  .card, .user-info-card, .success-card, .orders-list, .menu-list,
  .booking-form, .hero, .section, .order-card, .pay-card, .amount-card,
  .join-form .group { margin: 16px 0; }
}

/* 小屏手机 (320px - 480px) */
@media (max-width: 480px) {
  .container { padding:0 14px; }

  /* 标题和文字调整 */
  h1 { font-size:1.5rem; line-height: 1.3; }
  h2 { font-size:1.3rem; line-height: 1.3; }
  h3 { font-size:1.1rem; line-height: 1.3; }

  /* 按钮优化 */
  .btn {
    font-size:.9rem;
    padding:12px 18px;
    min-height: 44px; /* 确保触摸目标 */
    border-radius: 12px;
  }

  /* 卡片优化 */
  .card, .user-info-card, .success-card, .orders-list, .menu-list,
  .booking-form, .hero, .section, .order-card, .pay-card, .amount-card,
  .join-form .group {
    box-shadow: var(--shadow-sm);
    margin: 12px 0;
    border-radius: 16px;
  }

  /* 网格布局调整 */
  .service-grid { gap:12px; }

  /* 表单元素优化 */
  input, select, textarea {
    font-size:16px; /* 防止iOS缩放 */
    min-height: 48px;
    padding: 14px 16px;
  }

  /* 导航优化 */
  .category-tab, .tab {
    padding:10px 14px;
    font-size:.8rem;
    min-height: 44px;
  }

  /* 移动端底部导航栏布局调整 */
  .App.has-bottom-nav {
    padding-bottom: 60px;
  }
}

/* 超小屏手机 (≤360px) */
@media (max-width: 360px) {
  .container { padding:0 12px; }

  /* 按钮进一步优化 */
  .btn {
    font-size:.85rem;
    padding:11px 16px;
    min-height: 44px;
  }

  /* 表单元素 */
  input, select, textarea {
    font-size:16px;
    padding: 12px 14px;
    min-height: 44px;
  }

  /* 标签和选项卡 */
  .category-tab, .tab {
    padding:8px 12px;
    font-size:.75rem;
    min-height: 44px;
  }

  /* 卡片内边距调整 */
  .card, .user-info-card, .success-card, .orders-list, .menu-list,
  .booking-form, .hero, .section, .order-card, .pay-card, .amount-card,
  .join-form .group {
    padding: 16px 14px;
    margin: 10px 0;
  }

  /* 超小屏幕底部导航栏布局调整 */
  .App.has-bottom-nav {
    padding-bottom: 56px;
  }
}

/* 触摸设备优化 */
@media (pointer: coarse) {
  /* 确保所有可点击元素有足够的触摸区域 */
  .btn, .submit-btn, .book-now, .confirm-btn, .edit-btn, .detail-btn, .book-btn {
    padding: 14px 24px;
    min-height: 48px;
    min-width: 48px;
  }

  /* 导航图标优化 */
  .nav-item .icon, .nav-icon {
    font-size: 1.4rem;
    min-width: 32px;
    min-height: 32px;
  }

  /* 表单控件触摸优化 */
  input, select, textarea {
    min-height: 48px;
    padding: 16px;
  }

  /* 选项卡和分类标签 */
  .category-tab, .tab {
    min-height: 48px;
    padding: 12px 20px;
  }

  /* 菜单项触摸区域 */
  .menu-item {
    min-height: 56px;
    padding: 16px 20px;
  }

  /* 链接和可点击区域 */
  a, button, [role="button"] {
    min-height: 44px;
    min-width: 44px;
  }
}

/* 减少运动偏好：去除大幅过渡/缩放 */
@media (prefers-reduced-motion: reduce) {
  * { animation-duration:0.01ms !important; animation-iteration-count:1 !important; transition-duration:0.01ms !important; scroll-behavior:auto !important; }
  .service-card:hover, .pay-option:hover, .menu-item:hover, .card:hover { transform:none !important; }
}

/* 移动端性能优化 */
@media (max-width: 768px) {
  /* 减少阴影和动画以提升性能 */
  .card:hover, .user-info-card:hover, .booking-form:hover {
    box-shadow: var(--shadow-md); /* 减少hover效果 */
  }

  /* 优化滚动性能 */
  .category-tabs, .tabs {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }

  /* 移动端图片优化 */
  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: var(--radius-md);
  }

  .img-container {
    border-radius: var(--radius-md);
  }

  .img-responsive {
    border-radius: var(--radius-md);
  }

  /* 减少图片hover效果以提升性能 */
  .img-responsive:hover {
    transform: none;
  }

  /* 服务卡片图片优化 */
  .service-image img {
    object-fit: cover;
    border-radius: var(--radius-md);
  }

  /* 头像图片优化 */
  .user-avatar img {
    border-radius: 50%;
    object-fit: cover;
  }
}

/* 横屏模式优化 */
@media (max-width: 768px) and (orientation: landscape) {
  .service-header, .booking-header, .payment-header, .detail-header,
  .join-header, .my-header, .profile-header, .success-header {
    padding: 12px 20px; /* 减少垂直空间 */
  }

  .home-header {
    padding: 40px 0 30px; /* 减少头部空间 */
  }

  /* 底部导航在横屏时调整 */
  .bottom-nav {
    height: 56px;
  }

  .nav-item {
    min-height: 56px;
    font-size: 0.7rem;
  }
}

/* 高对比度模式（简易辅助） */
@media (forced-colors: active) {
  :root { --color-primary: CanvasText; --color-primary-accent: CanvasText; }
  .btn, .submit-btn, .confirm-btn, .book-now { background: ButtonFace !important; color: ButtonText !important; border: 1px solid ButtonText !important; }
  .category-tab.active, .tab.active { background: Highlight !important; color: HighlightText !important; }
}

/* ==========================================================
   Legacy compatibility (原有类保留，无功能变化，仅覆盖)
   ========================================================== */
.App-link { color: var(--color-primary); }

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;+DAE+D;AAC/D;EACE,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB,EAAE,OAAO;EACjC,+BAA+B,EAAE,SAAS;EAC1C,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;EAC/C,+CAA+C;EAC/C,uHAAuH;AACzH;;AAEA,mBAAmB;AACnB;EACE;IACE,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;IACvB,8BAA8B;IAC9B,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,qCAAqC;IACrC,qCAAqC;IACrC,uCAAuC;EACzC;AACF;;AAEA;;+DAE+D;AAC/D,OAAO,eAAe,EAAE;AACxB,OAAO,SAAS,EAAE,8BAA8B,EAAE,2BAA2B,EAAE,wBAAwB,EAAE,mCAAmC,EAAE;;AAE9I,yBAAyB,sBAAsB,EAAE;;AAEjD,IAAI,2BAA2B,EAAE,qBAAqB,EAAE,wCAAwC,EAAE;AAClG,UAAU,iCAAiC,EAAE;;AAE7C,cAAc;AACd;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB,EAAE,aAAa;AACvC;;AAEA,cAAc;AACd;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,UAAU,EAAE,cAAc;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,kBAAkB,KAAK,uBAAuB,CAAC,EAAE,OAAO,yBAAyB,CAAC,EAAE;AACpF,yBAAyB,KAAK,SAAS,EAAE,0BAA0B,CAAC,EAAE,OAAO,SAAS,EAAE,uBAAuB,CAAC,EAAE;AAClH,uBAAuB,UAAU,uCAAuC,CAAC,EAAE,MAAM,uCAAuC,CAAC,EAAE;;AAE3H,cAAc;AACd;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;;+DAE+D;AAC/D,aAAa,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;;AAE7D,WAAW;AACX;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,wHAAwH;EACxH,kBAAkB;AACpB;AACA;;sBAEsB,4BAA4B,EAAE;;AAEpD,YAAY;AACZ;EACE,mFAAmF;EACnF,UAAU,EAAE,iBAAiB,EAAE,YAAY,EAAE,kBAAkB,EAAE,wCAAwC;EACzG,kBAAkB,EAAE,UAAU;AAChC;AACA,wJAAwJ,kBAAkB,EAAE,mBAAmB,EAAE;;AAEjM,WAAW;AACX,YAAY,UAAU,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,UAAU,EAAE,2EAA2E,EAAE;AACtJ,kBAAkB,SAAS,EAAE,0BAA0B,EAAE;AACzD,0BAA0B,YAAY,EAAE,6BAA6B,EAAE,+BAA+B,EAAE;;AAExG;;+DAE+D;AAC/D;EACE,oBAAoB;EACpB,wCAAwC;EACxC,0BAA0B;EAC1B,eAAe,EAAE,WAAW;AAC9B;;AAEA;EACE,mBAAmB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,OAAO,EAAE,eAAe;EACzF,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB;EACzE,oFAAoF;EACpF,UAAU,EAAE,WAAW,EAAE,+BAA+B,EAAE,cAAc;EACxE,iBAAiB,EAAE,eAAe,EAAE,iBAAiB;EACrD,kHAAkH;EAClH,2EAA2E;AAC7E;AACA,cAAc,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,uFAAuF,EAAE,SAAS,EAAE,yCAAyC,EAAE;AACrM,aAAa,0BAA0B,EAAE,qCAAqC,EAAE;AAChF,oBAAoB,SAAS,EAAE;AAC/B,cAAc,uBAAuB,EAAE,0FAA0F,EAAE;AACnI,qBAAqB,YAAY,EAAE,6BAA6B,EAAE;;AAElE,iBAAiB,gCAAgC,EAAE,2BAA2B,EAAE,yEAAyE,EAAE;AAC3J,uBAAuB,oCAAoC,EAAE;AAC7D,wBAAwB,kBAAkB,EAAE;;AAE5C;EACE,oFAAoF;EACpF,UAAU,EAAE,WAAW,EAAE,eAAe;EACxC,kHAAkH;AACpH;AACA;EACE,mFAAmF;EACnF,2BAA2B;EAC3B,qCAAqC;AACvC;AACA,8CAA8C,mDAAmD,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAExI,YAAY,eAAe,EAAE,0BAA0B,EAAE,eAAe,EAAE,qCAAqC,EAAE,iCAAiC,EAAE;AACpJ,iCAAiC,+BAA+B,EAAE,UAAU,EAAE;AAC9E,0BAA0B,YAAY,EAAE,6BAA6B,EAAE;;AAEvE,iCAAiC;AACjC,sBAAsB,iBAAiB,EAAE,eAAe,EAAE;AAC1D,oCAAoC,oFAAoF,EAAE,UAAU,EAAE,WAAW,EAAE,yCAAyC,EAAE;AAC9L,kDAAkD,YAAY,EAAE,6BAA6B,EAAE;;AAE/F;;+DAE+D;AAC/D,cAAc,eAAe,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AAC1E,IAAI,eAAe,EAAE;AACrB,QAAQ,2BAA2B,EAAE;;AAErC;;+DAE+D;AAC/D,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,2CAA2C,EAAE,+BAA+B;EAC5E,+BAA+B,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,0HAA0H;EAChN,eAAe,EAAE,SAAS;AAC5B;AACA,4CAA4C,YAAY,EAAE,iCAAiC,EAAE,6BAA6B,EAAE;AAC5H,WAAW,gBAAgB,EAAE;AAC7B,gBAAgB,yBAAyB,EAAE;;AAE3C;;+DAE+D;AAC/D,WAAW,+BAA+B,EAAE;AAC5C,QAAQ,kCAAkC,EAAE;AAC5C,SAAS,iCAAiC,EAAE;;AAE5C,WAAW,UAAU,EAAE,8BAA8B,EAAE,aAAa,EAAE;;AAEtE,yCAAyC;AACzC,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,sBAAsB,EAAE;AACpD,4BAA4B,0BAA0B,EAAE,kBAAkB,EAAE;AAC5E,kCAAkC,0BAA0B,EAAE;;AAE9D,sBAAsB;AACtB,4BAA4B,YAAY,EAAE,6BAA6B,EAAE;;AAEzE;;+DAE+D;;AAE/D,6BAA6B;AAC7B;EACE,aAAa,cAAc,EAAE;EAC7B,OAAO,gBAAgB,EAAE,iBAAiB,EAAE;;EAE5C,WAAW;EACX;;sBAEoB,cAAc,EAAE;AACtC;;AAEA,yBAAyB;AACzB;EACE,aAAa,cAAc,EAAE;;EAE7B,YAAY;EACZ,KAAK,gBAAgB,EAAE,gBAAgB,EAAE;EACzC,KAAK,gBAAgB,EAAE,gBAAgB,EAAE;EACzC,KAAK,gBAAgB,EAAE,gBAAgB,EAAE;;EAEzC,SAAS;EACT;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB,EAAE,WAAW;IAC7B,mBAAmB;EACrB;;EAEA,SAAS;EACT;;;IAGE,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;EACrB;;EAEA,WAAW;EACX,gBAAgB,QAAQ,EAAE;;EAE1B,WAAW;EACX;IACE,cAAc,EAAE,YAAY;IAC5B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,SAAS;EACT;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,oBAAoB;EACtB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa,cAAc,EAAE;;EAE7B,YAAY;EACZ;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,SAAS;EACT;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,YAAY;EACZ;;;IAGE,kBAAkB;IAClB,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,oBAAoB;EACtB;AACF;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA,aAAa;EACb;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA,aAAa;EACb;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,aAAa;EACb;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,IAAI,oCAAoC,EAAE,sCAAsC,EAAE,qCAAqC,EAAE,+BAA+B,EAAE;EAC1J,wEAAwE,yBAAyB,EAAE;AACrG;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB;IACE,4BAA4B,EAAE,cAAc;EAC9C;;EAEA,WAAW;EACX;IACE,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA,YAAY;EACZ;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA,qBAAqB;EACrB;IACE,eAAe;EACjB;;EAEA,aAAa;EACb;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;;IAEE,kBAAkB,EAAE,WAAW;EACjC;;EAEA;IACE,oBAAoB,EAAE,WAAW;EACnC;;EAEA,eAAe;EACf;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE,QAAQ,2BAA2B,EAAE,kCAAkC,EAAE;EACzE,6CAA6C,iCAAiC,EAAE,4BAA4B,EAAE,uCAAuC,EAAE;EACvJ,oCAAoC,gCAAgC,EAAE,+BAA+B,EAAE;AACzG;;AAEA;;+DAE+D;AAC/D,YAAY,2BAA2B,EAAE","sourcesContent":["/* ==========================================================\r\n   Design Tokens / Theme\r\n   ========================================================== */\r\n:root {\r\n  --color-bg: #f5f7fa;\r\n  --color-surface: #ffffff;\r\n  --color-surface-alt: #f8f9fc;\r\n  --color-border: #eef0f5;\r\n  --color-border-strong: #dfe3ea;\r\n  --color-text: #2f3441;\r\n  --color-text-sec: #667085;\r\n  --color-muted: #98a0ad;\r\n  --color-primary: #6366f1; /* 主色 */\r\n  --color-primary-accent: #4f46e5; /* 渐变副色 */\r\n  --color-primary-hover: #5457e8;\r\n  --color-primary-active: #4547d9;\r\n  --color-danger: #f56c6c;\r\n  --color-warning-bg: #fff7d6;\r\n  --color-success-bg: #e6fbeb;\r\n  --radius-xs: 4px;\r\n  --radius-sm: 6px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n  --radius-xl: 18px;\r\n  --shadow-sm: 0 1px 4px rgba(0,0,0,0.06);\r\n  --shadow-md: 0 2px 8px rgba(0,0,0,0.08);\r\n  --shadow-lg: 0 4px 16px rgba(0,0,0,0.12);\r\n  --focus-ring: 0 0 0 3px rgba(99,102,241,.35);\r\n  --transition-fast: .18s cubic-bezier(.4,0,.2,1);\r\n  --transition-base: .28s cubic-bezier(.4,0,.2,1);\r\n  --font-stack: -apple-system,BlinkMacSystemFont,\"Segoe UI\",\"PingFang SC\",\"Hiragino Sans GB\",\"Microsoft YaHei\",sans-serif;\r\n}\r\n\r\n/* Dark mode (可选) */\r\n@media (prefers-color-scheme: dark) {\r\n  :root {\r\n    --color-bg: #1f242d;\r\n    --color-surface: #2a303b;\r\n    --color-surface-alt: #323a46;\r\n    --color-border: #39424f;\r\n    --color-border-strong: #485364;\r\n    --color-text: #f5f7fa;\r\n    --color-text-sec: #c3c9d2;\r\n    --color-muted: #9aa4b2;\r\n    --shadow-sm: 0 1px 3px rgba(0,0,0,.4);\r\n    --shadow-md: 0 2px 8px rgba(0,0,0,.5);\r\n    --shadow-lg: 0 4px 18px rgba(0,0,0,.55);\r\n  }\r\n}\r\n\r\n/* ==========================================================\r\n   Base / Reset (轻量增强)\r\n   ========================================================== */\r\nhtml { font-size: 16px; }\r\nbody { margin: 0; font-family: var(--font-stack); background: var(--color-bg); color: var(--color-text); -webkit-font-smoothing: antialiased; }\r\n\r\n*, *::before, *::after { box-sizing: border-box; }\r\n\r\na { color: var(--color-primary); text-decoration: none; transition: color var(--transition-fast); }\r\na:hover { color: var(--color-primary-hover); }\r\n\r\n/* 图片和媒体内容优化 */\r\nimg {\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  border-radius: inherit; /* 继承父元素的圆角 */\r\n}\r\n\r\n/* 特定图片类型的优化 */\r\n.service-thumb {\r\n  object-fit: cover;\r\n}\r\n\r\n.nav-icon {\r\n  object-fit: contain;\r\n}\r\n\r\n/* 响应式图片容器 */\r\n.img-container {\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n.img-responsive {\r\n  width: 100%;\r\n  height: auto;\r\n  object-fit: cover;\r\n  transition: transform var(--transition-base);\r\n}\r\n\r\n.img-responsive:hover {\r\n  transform: scale(1.02);\r\n}\r\n\r\n/* 图片加载优化 */\r\nimg[loading=\"lazy\"] {\r\n  opacity: 1; /* 修复：确保图片可见 */\r\n  transition: opacity 0.3s;\r\n}\r\n\r\nimg[loading=\"lazy\"].loaded {\r\n  opacity: 1;\r\n}\r\n\r\n/* 图片占位符 */\r\n.img-placeholder {\r\n  background: var(--color-surface-alt);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--color-muted);\r\n  font-size: 0.8rem;\r\n  min-height: 120px;\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }\r\n@keyframes fadeSlideUp { 0% { opacity:0; transform:translateY(12px);} 100% { opacity:1; transform:translateY(0);} }\r\n@keyframes pulseSoft { 0%,100% { box-shadow:0 0 0 0 rgba(99,102,241,.35);} 50% { box-shadow:0 0 0 6px rgba(99,102,241,0);} }\r\n\r\n/* App容器基础样式 */\r\n.App {\r\n  text-align: center;\r\n  background: var(--color-bg);\r\n  min-height: 100vh;\r\n}\r\n\r\n/* 有底部导航栏时的布局 */\r\n.App.has-bottom-nav {\r\n  padding-bottom: 64px;\r\n}\r\n\r\n/* 没有底部导航栏时的布局 */\r\n.App.no-bottom-nav {\r\n  padding-bottom: 0;\r\n}\r\n\r\n/* ==========================================================\r\n   Layout Helpers\r\n   ========================================================== */\r\n.container { max-width:750px; margin:0 auto; padding:0 18px; }\r\n\r\n/* 卡片统一样式 */\r\n.card, .user-info-card, .success-card, .orders-list, .menu-list, .booking-form, .hero, .section, .order-card, .pay-card, .amount-card, .join-form .group {\r\n  background: var(--color-surface);\r\n  border-radius: var(--radius-lg);\r\n  border: 1px solid var(--color-border);\r\n  box-shadow: var(--shadow-md);\r\n  transition: box-shadow var(--transition-base), transform var(--transition-base), background-color var(--transition-fast);\r\n  position: relative;\r\n}\r\n.card:hover:not(.no-hover),\r\n.user-info-card:hover,\r\n.booking-form:hover { box-shadow: var(--shadow-lg); }\r\n\r\n/* 统一顶部标题栏 */\r\n.service-header, .booking-header, .payment-header, .detail-header, .join-header, .my-header, .profile-header, .success-header {\r\n  background: linear-gradient(90deg,var(--color-primary),var(--color-primary-accent));\r\n  color:#fff; padding:16px 20px; display:flex; align-items:center; backdrop-filter:saturate(180%) blur(6px);\r\n  position: relative; z-index:10;\r\n}\r\n.service-header h1, .booking-header h1, .payment-header h1, .detail-header h1, .join-header h1, .my-header h1, .profile-header h1, .success-header h1 { font-size:1.125rem; letter-spacing:.5px; }\r\n\r\n/* 返回按钮统一 */\r\n.back-btn { color:#fff; font-size:.95rem; margin-right:14px; opacity:.9; transition:opacity var(--transition-fast), transform var(--transition-fast); }\r\n.back-btn:hover { opacity:1; transform:translateX(-2px); }\r\n.back-btn:focus-visible { outline:none; box-shadow: var(--focus-ring); border-radius: var(--radius-sm); }\r\n\r\n/* ==========================================================\r\n   Buttons\r\n   ========================================================== */\r\n.btn, .submit-btn, .book-now, .confirm-btn, .edit-btn, .code-btn, .tab, .detail-btn, .book-btn, .pay-option, .category-tab {\r\n  font-family: inherit;\r\n  -webkit-tap-highlight-color: transparent;\r\n  touch-action: manipulation;\r\n  min-height:44px; /* 确保触摸面积 */\r\n}\r\n\r\n.btn {\r\n  display:inline-flex; align-items:center; justify-content:center; gap:6px; line-height:1.1;\r\n  padding:12px 22px; font-size:.95rem; font-weight:600; letter-spacing:.3px;\r\n  background: linear-gradient(135deg,var(--color-primary),var(--color-primary-accent));\r\n  color:#fff; border:none; border-radius: var(--radius-md); cursor:pointer;\r\n  position:relative; overflow:hidden; isolation:isolate;\r\n  transition: background var(--transition-fast), transform var(--transition-fast), box-shadow var(--transition-fast);\r\n  box-shadow:0 2px 4px rgba(0,0,0,.12), inset 0 0 0 1px rgba(255,255,255,.08);\r\n}\r\n.btn::after { content:\"\"; position:absolute; inset:0; background:radial-gradient(circle at 30% 30%,rgba(255,255,255,.35),rgba(255,255,255,0)); opacity:0; transition:opacity var(--transition-fast); }\r\n.btn:hover { transform:translateY(-2px); box-shadow:0 4px 12px rgba(0,0,0,.18); }\r\n.btn:hover::after { opacity:1; }\r\n.btn:active { transform:translateY(0); background: linear-gradient(135deg,var(--color-primary-hover),var(--color-primary-active)); }\r\n.btn:focus-visible { outline:none; box-shadow: var(--focus-ring); }\r\n\r\n.btn-secondary { background: var(--color-surface); color: var(--color-primary); box-shadow:0 1px 3px rgba(0,0,0,.08), inset 0 0 0 1px var(--color-border); }\r\n.btn-secondary:hover { background: var(--color-surface-alt); }\r\n.btn-secondary:active { background:#eceef5; }\r\n\r\n.submit-btn, .book-now, .confirm-btn, .edit-btn, .detail-btn, .book-btn {\r\n  background: linear-gradient(135deg,var(--color-primary),var(--color-primary-accent));\r\n  color:#fff; border:none; font-weight:600;\r\n  transition: background var(--transition-fast), transform var(--transition-fast), box-shadow var(--transition-fast);\r\n}\r\n.submit-btn:hover:not(:disabled), .book-now:hover, .confirm-btn:hover:not(:disabled), .edit-btn:hover, .detail-btn:hover, .book-btn:hover {\r\n  background: linear-gradient(135deg,var(--color-primary-hover),var(--color-primary));\r\n  transform: translateY(-2px);\r\n  box-shadow:0 4px 12px rgba(0,0,0,.18);\r\n}\r\n.submit-btn:disabled, .confirm-btn:disabled { background: linear-gradient(135deg,#c9ced8,#c9ced8); cursor:not-allowed; box-shadow:none; }\r\n\r\n.code-btn { background:#fff; color:var(--color-primary); font-weight:600; border:1px solid var(--color-primary); transition:var(--transition-fast); }\r\n.code-btn:hover:not(:disabled) { background:var(--color-primary); color:#fff; }\r\n.code-btn:focus-visible { outline:none; box-shadow: var(--focus-ring); }\r\n\r\n/* Tabs / Category chips refine */\r\n.category-tab, .tab { position:relative; font-weight:500; }\r\n.category-tab.active, .tab.active { background: linear-gradient(135deg,var(--color-primary),var(--color-primary-accent)); color:#fff; border:none; box-shadow:0 2px 6px rgba(99,102,241,.35); }\r\n.category-tab:focus-visible, .tab:focus-visible { outline:none; box-shadow: var(--focus-ring); }\r\n\r\n/* ==========================================================\r\n   Typography Helpers\r\n   ========================================================== */\r\nh1,h2,h3,h4 { font-weight:700; color:var(--color-text); line-height:1.25; }\r\np { line-height:1.6; }\r\nsmall { color:var(--color-text-sec); }\r\n\r\n/* ==========================================================\r\n   Form Elements\r\n   ========================================================== */\r\ninput, select, textarea { font-family:inherit; }\r\ninput, select, textarea {\r\n  border:1px solid var(--color-border-strong); background:var(--color-surface);\r\n  border-radius: var(--radius-md); padding:12px 14px; font-size:16px; line-height:1.25; transition:border-color var(--transition-fast), box-shadow var(--transition-fast), background-color var(--transition-fast);\r\n  min-height:48px; /* 触摸区域 */\r\n}\r\ninput:focus, select:focus, textarea:focus { outline:none; border-color:var(--color-primary); box-shadow: var(--focus-ring); }\r\ntextarea { resize: vertical; }\r\n::placeholder { color: var(--color-muted); }\r\n\r\n/* ==========================================================\r\n   Utilities\r\n   ========================================================== */\r\n.fade-in { animation: fadeSlideUp .6s both; }\r\n.spin { animation: spin 1s linear infinite; }\r\n.pulse { animation:pulseSoft 2.4s infinite; }\r\n\r\n.divider { height:1px; background:var(--color-border); margin:20px 0; }\r\n\r\n/* Scrollbar refinement for webkit (可选) */\r\n::-webkit-scrollbar { width:10px; height:10px; }\r\n::-webkit-scrollbar-track { background:transparent; }\r\n::-webkit-scrollbar-thumb { background:rgba(0,0,0,.15); border-radius:20px; }\r\n::-webkit-scrollbar-thumb:hover { background:rgba(0,0,0,.25); }\r\n\r\n/* Focus ring helper */\r\n.focus-ring:focus-visible { outline:none; box-shadow: var(--focus-ring); }\r\n\r\n/* ==========================================================\r\n   Responsive Breakpoints System\r\n   ========================================================== */\r\n\r\n/* 大屏手机和小平板 (481px - 768px) */\r\n@media (max-width: 768px) and (min-width: 481px) {\r\n  .container { padding:0 16px; }\r\n  .btn { font-size:.95rem; padding:12px 20px; }\r\n\r\n  /* 卡片间距调整 */\r\n  .card, .user-info-card, .success-card, .orders-list, .menu-list,\r\n  .booking-form, .hero, .section, .order-card, .pay-card, .amount-card,\r\n  .join-form .group { margin: 16px 0; }\r\n}\r\n\r\n/* 小屏手机 (320px - 480px) */\r\n@media (max-width: 480px) {\r\n  .container { padding:0 14px; }\r\n\r\n  /* 标题和文字调整 */\r\n  h1 { font-size:1.5rem; line-height: 1.3; }\r\n  h2 { font-size:1.3rem; line-height: 1.3; }\r\n  h3 { font-size:1.1rem; line-height: 1.3; }\r\n\r\n  /* 按钮优化 */\r\n  .btn {\r\n    font-size:.9rem;\r\n    padding:12px 18px;\r\n    min-height: 44px; /* 确保触摸目标 */\r\n    border-radius: 12px;\r\n  }\r\n\r\n  /* 卡片优化 */\r\n  .card, .user-info-card, .success-card, .orders-list, .menu-list,\r\n  .booking-form, .hero, .section, .order-card, .pay-card, .amount-card,\r\n  .join-form .group {\r\n    box-shadow: var(--shadow-sm);\r\n    margin: 12px 0;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  /* 网格布局调整 */\r\n  .service-grid { gap:12px; }\r\n\r\n  /* 表单元素优化 */\r\n  input, select, textarea {\r\n    font-size:16px; /* 防止iOS缩放 */\r\n    min-height: 48px;\r\n    padding: 14px 16px;\r\n  }\r\n\r\n  /* 导航优化 */\r\n  .category-tab, .tab {\r\n    padding:10px 14px;\r\n    font-size:.8rem;\r\n    min-height: 44px;\r\n  }\r\n\r\n  /* 移动端底部导航栏布局调整 */\r\n  .App.has-bottom-nav {\r\n    padding-bottom: 60px;\r\n  }\r\n}\r\n\r\n/* 超小屏手机 (≤360px) */\r\n@media (max-width: 360px) {\r\n  .container { padding:0 12px; }\r\n\r\n  /* 按钮进一步优化 */\r\n  .btn {\r\n    font-size:.85rem;\r\n    padding:11px 16px;\r\n    min-height: 44px;\r\n  }\r\n\r\n  /* 表单元素 */\r\n  input, select, textarea {\r\n    font-size:16px;\r\n    padding: 12px 14px;\r\n    min-height: 44px;\r\n  }\r\n\r\n  /* 标签和选项卡 */\r\n  .category-tab, .tab {\r\n    padding:8px 12px;\r\n    font-size:.75rem;\r\n    min-height: 44px;\r\n  }\r\n\r\n  /* 卡片内边距调整 */\r\n  .card, .user-info-card, .success-card, .orders-list, .menu-list,\r\n  .booking-form, .hero, .section, .order-card, .pay-card, .amount-card,\r\n  .join-form .group {\r\n    padding: 16px 14px;\r\n    margin: 10px 0;\r\n  }\r\n\r\n  /* 超小屏幕底部导航栏布局调整 */\r\n  .App.has-bottom-nav {\r\n    padding-bottom: 56px;\r\n  }\r\n}\r\n\r\n/* 触摸设备优化 */\r\n@media (pointer: coarse) {\r\n  /* 确保所有可点击元素有足够的触摸区域 */\r\n  .btn, .submit-btn, .book-now, .confirm-btn, .edit-btn, .detail-btn, .book-btn {\r\n    padding: 14px 24px;\r\n    min-height: 48px;\r\n    min-width: 48px;\r\n  }\r\n\r\n  /* 导航图标优化 */\r\n  .nav-item .icon, .nav-icon {\r\n    font-size: 1.4rem;\r\n    min-width: 32px;\r\n    min-height: 32px;\r\n  }\r\n\r\n  /* 表单控件触摸优化 */\r\n  input, select, textarea {\r\n    min-height: 48px;\r\n    padding: 16px;\r\n  }\r\n\r\n  /* 选项卡和分类标签 */\r\n  .category-tab, .tab {\r\n    min-height: 48px;\r\n    padding: 12px 20px;\r\n  }\r\n\r\n  /* 菜单项触摸区域 */\r\n  .menu-item {\r\n    min-height: 56px;\r\n    padding: 16px 20px;\r\n  }\r\n\r\n  /* 链接和可点击区域 */\r\n  a, button, [role=\"button\"] {\r\n    min-height: 44px;\r\n    min-width: 44px;\r\n  }\r\n}\r\n\r\n/* 减少运动偏好：去除大幅过渡/缩放 */\r\n@media (prefers-reduced-motion: reduce) {\r\n  * { animation-duration:0.01ms !important; animation-iteration-count:1 !important; transition-duration:0.01ms !important; scroll-behavior:auto !important; }\r\n  .service-card:hover, .pay-option:hover, .menu-item:hover, .card:hover { transform:none !important; }\r\n}\r\n\r\n/* 移动端性能优化 */\r\n@media (max-width: 768px) {\r\n  /* 减少阴影和动画以提升性能 */\r\n  .card:hover, .user-info-card:hover, .booking-form:hover {\r\n    box-shadow: var(--shadow-md); /* 减少hover效果 */\r\n  }\r\n\r\n  /* 优化滚动性能 */\r\n  .category-tabs, .tabs {\r\n    -webkit-overflow-scrolling: touch;\r\n    scroll-behavior: smooth;\r\n  }\r\n\r\n  /* 移动端图片优化 */\r\n  img {\r\n    max-width: 100%;\r\n    height: auto;\r\n    object-fit: cover;\r\n    border-radius: var(--radius-md);\r\n  }\r\n\r\n  .img-container {\r\n    border-radius: var(--radius-md);\r\n  }\r\n\r\n  .img-responsive {\r\n    border-radius: var(--radius-md);\r\n  }\r\n\r\n  /* 减少图片hover效果以提升性能 */\r\n  .img-responsive:hover {\r\n    transform: none;\r\n  }\r\n\r\n  /* 服务卡片图片优化 */\r\n  .service-image img {\r\n    object-fit: cover;\r\n    border-radius: var(--radius-md);\r\n  }\r\n\r\n  /* 头像图片优化 */\r\n  .user-avatar img {\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n  }\r\n}\r\n\r\n/* 横屏模式优化 */\r\n@media (max-width: 768px) and (orientation: landscape) {\r\n  .service-header, .booking-header, .payment-header, .detail-header,\r\n  .join-header, .my-header, .profile-header, .success-header {\r\n    padding: 12px 20px; /* 减少垂直空间 */\r\n  }\r\n\r\n  .home-header {\r\n    padding: 40px 0 30px; /* 减少头部空间 */\r\n  }\r\n\r\n  /* 底部导航在横屏时调整 */\r\n  .bottom-nav {\r\n    height: 56px;\r\n  }\r\n\r\n  .nav-item {\r\n    min-height: 56px;\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n\r\n/* 高对比度模式（简易辅助） */\r\n@media (forced-colors: active) {\r\n  :root { --color-primary: CanvasText; --color-primary-accent: CanvasText; }\r\n  .btn, .submit-btn, .confirm-btn, .book-now { background: ButtonFace !important; color: ButtonText !important; border: 1px solid ButtonText !important; }\r\n  .category-tab.active, .tab.active { background: Highlight !important; color: HighlightText !important; }\r\n}\r\n\r\n/* ==========================================================\r\n   Legacy compatibility (原有类保留，无功能变化，仅覆盖)\r\n   ========================================================== */\r\n.App-link { color: var(--color-primary); }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
